import { PracticeSetAnalyticsComponent } from './practice-set-analytics.component';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from 'app/modules/shared/shared.module';
import { TableModule } from '../table/table.module';
import { UsageModule } from '../user-details/usage/usage.module';
import { DateSelectorModule } from '../date-selector/date-selector.module';
import { DataExportModule } from '../data-export/data-export.module';
import { EramLessonAnalyticsComponent } from './eram-lesson-analytics/eram-lesson-analytics.component';
import { DateRangeModule } from '../date-range/date-range.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTableModule } from '@angular/material/table';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { BasicAdvanceAnalyticComponent } from './basic-advance-analytic/basic-advance-analytic.component';
import { MatSortModule } from '@angular/material/sort';
import { BasicAnalyticsComponent } from './basic-analytics/basic-analytics.component';
import { AtcPracticeSetConsolidatedRatioTabAnalticsComponent } from './atc-practice-set-consolidated-ratio-tab-analtics/atc-practice-set-consolidated-ratio-tab-analtics.component';
import { AtcPracticeSetConsolidatedCountTabAnalticsComponent } from './atc-practice-set-consolidated-count-tab-analtics/atc-practice-set-consolidated-count-tab-analtics.component';
import { AtcPracticeSetCommandTypeAnalyticsComponent } from './atc-practice-set-command-type-analytics/atc-practice-set-command-type-analytics.component';
import { AtcPracticeSetAnalyticsComponent } from './atc-practice-set-analytics/atc-practice-set-analytics.component';
import { StarsLessonsConsolidatedCountAnalticsComponent } from './stars-lessons-consolidated-count-analtics/stars-lessons-consolidated-count-analtics.component';
import { StarsLessonsUsageCountAnalticsComponent } from './stars-lessons-usage-count-analtics/stars-lessons-usage-count-analtics.component';
import { StarsLessonsUsageGraphAnalticsComponent } from './stars-lessons-usage-graph-analtics/stars-lessons-usage-graph-analtics.component';
import { StarsLessonsAnalticsComponent } from './stars-lessons-analtics/stars-lessons-analtics.component';
import { StarsUserLessonSessionCountAnalticsComponent } from './stars-user-lesson-session-count-analtics/stars-user-lesson-session-count-analtics.component';
import { StarsLessonSessionDataAnalticsComponent } from './stars-lesson-session-data-analtics/stars-lesson-session-data-analtics.component';
import { DatePipe } from '@angular/common';

const routes = [
                {path: 'analytics/:id', component: PracticeSetAnalyticsComponent},
                {path: 'analytics/:id/:name', component: PracticeSetAnalyticsComponent},
                {path: 'analytics/view/:view/:id/:name', component: PracticeSetAnalyticsComponent},
                {path: 'analytics/user/:view/:id/:name/:username', component: PracticeSetAnalyticsComponent},
                {path: 'analytics/folder/:id/:folder/:name', component: PracticeSetAnalyticsComponent},
                {path: 'analytics/:id/:name/:username', component: PracticeSetAnalyticsComponent}
              ]

@NgModule({
  declarations: [PracticeSetAnalyticsComponent, EramLessonAnalyticsComponent,BasicAdvanceAnalyticComponent, BasicAnalyticsComponent, AtcPracticeSetConsolidatedRatioTabAnalticsComponent, 
    AtcPracticeSetConsolidatedCountTabAnalticsComponent, AtcPracticeSetCommandTypeAnalyticsComponent, AtcPracticeSetAnalyticsComponent, 
    StarsLessonsConsolidatedCountAnalticsComponent, StarsLessonsUsageCountAnalticsComponent, StarsLessonsUsageGraphAnalticsComponent, StarsLessonsAnalticsComponent, StarsUserLessonSessionCountAnalticsComponent, StarsLessonSessionDataAnalticsComponent],
  imports: [
    SharedModule,
    RouterModule.forChild(routes),
    MatCardModule,
    TableModule,
    MatProgressSpinnerModule,
    UsageModule,
    MatIconModule,
    DateSelectorModule,
    DataExportModule,
    MatButtonModule,
    DateRangeModule,
    MatTableModule,
    MatTooltipModule,
    MatPaginatorModule,
    MatSelectModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    FormsModule,
    MatSortModule
  ],
  exports: [PracticeSetAnalyticsComponent, EramLessonAnalyticsComponent, AtcPracticeSetConsolidatedRatioTabAnalticsComponent, 
    AtcPracticeSetConsolidatedCountTabAnalticsComponent, AtcPracticeSetCommandTypeAnalyticsComponent, 
    AtcPracticeSetAnalyticsComponent, StarsLessonsUsageCountAnalticsComponent, StarsLessonsUsageGraphAnalticsComponent],
  providers: [DatePipe] // Add DatePipe to providers
})
export class PracticeSetAnalyticsModule { }
